import { Component } from '@angular/core';

@Component({
  selector: 'proffeo-project',
  template: ''
})
export class EditProjectViewComponent {}
